// Lightweight pub-sub so non-component code (the axios response interceptor in
// api/api.js, which runs outside the React tree) can trigger a toast without needing
// React context. GlobalNotificationBar is the single subscriber, mounted once at the
// app root, so this fires no matter which page is currently active.
let listener = null;

// Most pages' own catch blocks show a hardcoded generic error (e.g. "Failed to update
// order") without checking why the call failed, so an access-denied response would
// otherwise stack a second, redundant toast on top of this one. Tracking when the last
// global error fired lets useNotification's local `show()` skip its own error toast for
// a brief window right after — see wasGlobalErrorShownRecently below.
let lastErrorAt = 0;
const SUPPRESS_WINDOW_MS = 500;

export function setGlobalNotificationListener(fn) {
  listener = fn;
}

export function notifyGlobal(message, type = 'error') {
  if (type === 'error') lastErrorAt = Date.now();
  if (listener) listener(message, type);
}

export function wasGlobalErrorShownRecently() {
  return Date.now() - lastErrorAt < SUPPRESS_WINDOW_MS;
}
